(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-scroller"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__lightboxInit) return;
  window.__lightboxInit = true;

  var openBox = null;

  function open(box) {
    if (!box || openBox === box) return;
    close();
    box.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { box.classList.add('is-open'); });
    });
    document.body.classList.add('lightbox-open');
    openBox = box;
    var closeBtn = box.querySelector('.lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!openBox) return;
    var box = openBox;
    openBox = null;
    box.classList.remove('is-open');
    document.body.classList.remove('lightbox-open');
    setTimeout(function () { box.hidden = true; }, 400);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lightbox-open]');
    if (opener) {
      e.preventDefault();
      open(document.getElementById(opener.getAttribute('data-lightbox-open')));
      return;
    }
    if (e.target.closest('[data-lightbox-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if ((e.key === 'Enter' || e.key === ' ') && document.activeElement) {
      var el = document.activeElement;
      if (el.hasAttribute('data-lightbox-open') && el.getAttribute('role') === 'button') {
        e.preventDefault();
        open(document.getElementById(el.getAttribute('data-lightbox-open')));
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vtInit) return;
  window.__vtInit = true;

  var activeCard = null;

  function cardVideo(card) { return card.querySelector('video'); }

  function muteCard(card) {
    var video = cardVideo(card);
    if (video) video.muted = true;
    card.classList.remove('vt-sound-on');
  }

  function freezeEnabled(card) {
    var section = card.closest('[data-vt-freeze]');
    return section && section.getAttribute('data-vt-freeze') === 'true';
  }

  function eachOther(current, fn) {
    document.querySelectorAll('.vt-card[data-vt-bound]').forEach(function (card) {
      if (card !== current) fn(card);
    });
  }

  /* Mute a card; if it was the active one, let the frozen cards resume. */
  function deactivate(card) {
    muteCard(card);
    if (activeCard === card) {
      activeCard = null;
      eachOther(card, function (other) {
        var video = cardVideo(other);
        if (video && other.hasAttribute('data-vt-inview')) video.play().catch(function () {});
      });
    }
  }

  /* Give this card sound; mute the rest and (optionally) freeze them. */
  function activate(card) {
    var video = cardVideo(card);
    if (!video) return;
    var freeze = freezeEnabled(card);
    eachOther(card, function (other) {
      muteCard(other);
      if (freeze) {
        var otherVideo = cardVideo(other);
        if (otherVideo) otherVideo.pause();
      }
    });
    activeCard = card;
    video.muted = false;
    card.classList.add('vt-sound-on');
    video.play().catch(function () {});
  }

  function setup() {
    var cards = document.querySelectorAll('.vt-card:not([data-vt-bound])');
    if (!cards.length) return;
    var io = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var card = entry.target;
            var video = cardVideo(card);
            if (!video) return;
            if (entry.isIntersecting) {
              card.setAttribute('data-vt-inview', '');
              var frozen = activeCard && activeCard !== card && freezeEnabled(activeCard);
              if (!frozen) video.play().catch(function () {});
            } else {
              card.removeAttribute('data-vt-inview');
              video.pause();
              deactivate(card);
            }
          });
        }, { threshold: 0.45 })
      : null;

    cards.forEach(function (card) {
      card.setAttribute('data-vt-bound', '');
      var video = cardVideo(card);
      if (!video) return;
      video.muted = true;
      video.loop = true;
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
      if (io) io.observe(card);
      card.addEventListener('click', function () {
        if (video.muted) activate(card);
        else deactivate(card);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();
})();
